module.exports = __webpack_public_path__ + "static/img/nocamera.9a4e65a5.jpg";